import React, { useState } from 'react';

const Testimonials = () => {
  const [isPaused, setIsPaused] = useState(false);

  const testimonials = [
    {
      id: 1,
      name: "Dr. Solomon G.",
      year: "Bought 2024",
      text: "Ermiyas provided a level of professionalism that is rare to find. He understood my needs for a luxury medical office and delivered a prime location in record time.",
      role: "Medical Director"
    },
    {
      id: 2,
      name: "Mekdes T.",
      year: "Bought 2023",
      text: "The market insights were invaluable. As a business owner, I value transparency and efficiency, and that is exactly what I received throughout the closing process.",
      role: "Hotelier"
    },
    {
      id: 3,
      name: "Dawit H.",
      year: "Bought 2025",
      text: "I was looking for a modern residence in the city center. Ermiyas's knowledge of the new luxury developments helped me secure my dream home before it hit the public market.",
      role: "Tech Executive"
    },
    {
      id: 4,
      name: "Zewditu A.",
      year: "Bought 2024",
      text: "Guidance you can trust. Being part of the diaspora, I needed someone reliable on the ground. Ermiyas handled every detail with absolute integrity.",
      role: "Diaspora Investor"
    },
    {
      id: 5,
      name: "Yonas B.",
      year: "Bought 2023",
      text: "Excellent negotiation skills. He managed to get me a 10% discount on my property purchase. Highly recommended for premium real estate services.",
      role: "Financial Analyst"
    },
    {
      id: 6,
      name: "Hiwot M.",
      year: "Bought 2025",
      text: "The attention to detail during the documentation process was impressive. Every step was smooth and clear. I am very happy with my new apartment.",
      role: "International Consultant"
    }
  ];

  const allTestimonials = [...testimonials, ...testimonials];

  const StarIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="#f3b33d">
      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
    </svg>
  );

  return (
    <>
      <style>
        {`
          .testimonials {
            background: #0a0f1c;
            padding: 0 !important; /* ZERO PADDING */
            margin: 0 !important;  /* ZERO MARGIN */
            width: 100%;
            display: block !important;
            overflow: hidden;
          }

          .testimonials-container {
            width: 100%;
            margin: 0 auto !important;
            padding: 0 !important;
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .section-header {
            width: 100%;
            text-align: center !important;
            margin: 0 0 20px 0 !important; /* Minimal gap only between title and slider */
            padding-top: 20px !important; /* Small space at the very top of the title */
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
          }

          .section-header h2 {
            color: #ffffff !important;
            font-size: 3rem;
            font-weight: 600;
            font-family: 'Cormorant Garamond', serif;
            margin: 0 !important;
            display: inline-block;
          }

          .section-subtitle {
            color: #9aa7b2;
            font-size: 1rem;
            max-width: 600px;
            margin: 5px auto 0 auto !important;
            font-family: 'Comfortaa', cursive;
          }

          .testimonials-wrapper {
            width: 100%;
            overflow: hidden;
            margin: 0 !important;
            padding: 0 0 20px 0 !important; /* Only enough padding to show the card shadow */
          }

          .testimonials-track {
            display: flex;
            gap: 20px;
            animation: testiMove 40s linear infinite;
            width: max-content;
          }

          @keyframes testiMove {
            0% { transform: translateX(0); }
            100% { transform: translateX(calc(-350px * 6 - 20px * 6)); }
          }

          .testimonial-card {
            width: 350px;
            background: rgba(255, 255, 255, 0.03);
            padding: 1.5rem;
            border-radius: 12px;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }

          @media (max-width: 768px) {
            .section-header h2 { font-size: 2.2rem; }
            .testimonial-card { width: 280px; }
            @keyframes testiMove {
              0% { transform: translateX(0); }
              100% { transform: translateX(calc(-280px * 6 - 20px * 6)); }
            }
          }
        `}
      </style>

      <section className="testimonials">
        <div className="testimonials-container">
          
          <div className="section-header">
            <h2 style={{color: '#ffffff'}}>
              Voices of <span style={{color: '#f3b33d'}}>Excellence</span>
            </h2>
            <p className="section-subtitle">
              The true measure of success is the trust built with our Ethiopian clients.
            </p>
          </div>

          <div 
            className="testimonials-wrapper"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <div className={`testimonials-track ${isPaused ? 'paused' : ''}`}>
              {allTestimonials.map((testimonial, index) => (
                <article key={`${testimonial.id}-${index}`} className="testimonial-card">
                  <div style={{display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '10px'}}>
                    <div style={{
                      width: '40px', height: '40px', borderRadius: '50%', 
                      background: 'linear-gradient(135deg, #f3b33d, #f6d69b)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: '#062030', fontWeight: 'bold'
                    }}>
                      {testimonial.name.charAt(0)}
                    </div>
                    <div>
                      <h4 style={{color: '#fff', margin: 0}}>{testimonial.name}</h4>
                      <div style={{color: '#f3b33d', fontSize: '0.8rem'}}>{testimonial.role}</div>
                    </div>
                  </div>
                  <div style={{display: 'flex', gap: '3px', marginBottom: '8px'}}>
                    {[...Array(5)].map((_, i) => <StarIcon key={i} />)}
                  </div>
                  <div style={{color: '#cfd9e0', fontStyle: 'italic', fontSize: '0.95rem'}}>"{testimonial.text}"</div>
                  <div style={{color: '#6a7682', fontSize: '0.8rem', marginTop: '10px'}}>{testimonial.year}</div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonials;